/** Main project script */
'use strict';



import {createApp, reactive} from 'vue';
// import CardCarousel from './components/card-carousel';
// import MapBox from './components/map-box';
// import GalleryCarousel from './components/gallery-carousel';
// import SuggestiveSearch from './components/suggestive-search';
import paginatedDocuments from "./components/paginated-documents.vue";
import CertificationBodyPage from "./components/certification-body-page.vue";
import BulletinPage from "./components/bulletin-page.vue";
import CountUp from 'vue-countup-v3';
import RtpMap from "./components/rtp-map";
import EventListingPanel from "./components/event-listing-panel.vue";

import {QuillEditor} from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';


// import Gallery from "./components/gallery";
// import InFocus from './components/in-focus';
// import OpenStreetMap from "./components/open-street-map";

// import "leaflet/dist/leaflet.css";

// import {debounce} from 'lodash';
// Vue.config.productionTip = false;
// Vue.config.devtools = false;


import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'
import {forEach} from "lodash";

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql

const store = reactive({
    dropdownOpen: null
});


const app = createApp({
    components: {
        paginatedDocuments,
        CertificationBodyPage,
        BulletinPage,
        CountUp,
        RtpMap,
        EventListingPanel,
        QuillEditor,
        VueEasyLightbox
    },
    // Shared app state
    data() {
        return {
            navigation: {
                open: false,
                openSubMenu: 0,
                searchBarOpen: false,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                mobileSearchBarOpen: false
            },
            collapseOpen: [],
            minPageHeight: null,
            scrolled: false,
            modal: 0,
            searchTerm: '',
            lightboxVisibleRef: null,
            lightboxIndexRef: null,
            searchElements: []
        };
    },
    computed: {
        horizontalNavShow: function () {
            if (navigation.mobileSearchBarOpen) {
                return false;
            }
            return true;
        }
    },
    methods: {
        handleScroll: function () {
            if (window.scrollY > 44) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        isItemCollapseOpen: function (item) {
            return this.collapseOpen.includes(item);
        },
        toggleCollapseOpen: function (item) {
            if (this.collapseOpen.includes(item)) {
                this.collapseOpen = this.collapseOpen.filter(i => i !== item);
            } else {
                this.collapseOpen.push(item);
            }
        },
        isItemDropdownOpen: function (item) {
            return store.dropdownOpen === item;
        },
        toggleDropdownOpen: function (item) {
            if (this.isItemDropdownOpen(item)) {
                store.dropdownOpen = null;
            } else {
                store.dropdownOpen = item;
            }
        },
        isMobileMenuSubMenuOpen: function (item) {
            return this.navigation.mobileMenuSubMenu === item;
        },
        toggleMobileMenuSubMenu: function (item) {
            if (this.isMobileMenuSubMenuOpen(item)) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = item;
            }
        },
        hiddenClear: function () {

        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        fixMobileSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.mobileSearchBarOpen = true;
            } else {
                this.navigation.mobileSearchBarOpen = false;
            }
        },
        toggleMobileSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.mobileSearchBarOpen = !this.navigation.mobileSearchBarOpen;
        },
        toggleSubmenu: function (id) {

            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                 this.navigation.mobileMenuOpen = true;
            } else {
                 this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.searchBarOpen = false;
            this.navigation.mobileMenuOpen = ! this.navigation.mobileMenuOpen;
        },
        toggleMobileSubmenu: function (id) {
            if (this.navigation.mobileMenuSubMenu === id) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = id;
            }
        },
        goTo: function (url, newTab) {
            if (!url) {
                return false;
            }
            newTab = newTab || false;
            if (newTab) {
                return window.open(url);
            }
            return window.location.href = url;
        },
        toggleLightbox: function (index) {
            console.log(index);
            this.lightboxIndexRef = index;
            this.lightboxVisibleRef = true;
        },
        hideLightbox: function () {
            this.lightboxVisibleRef = false;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[0].dataset?.presetClass?.trim().split(' ');
                let parent = targets[0].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));

        },
        scrollHelper: function (el, elClass, offset, callback) {
        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },
        setupLazyLoad: function () {
            document.addEventListener("DOMContentLoaded", function () {
                var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

                if ("IntersectionObserver" in window) {
                    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                entry.target.classList.add("lazy-visible");
                                lazyBackgroundObserver.unobserve(entry.target);
                            }
                        });
                    });

                    lazyBackgrounds.forEach(function (lazyBackground) {
                        lazyBackgroundObserver.observe(lazyBackground);
                    });
                }
            });

        },
        quicksearchInit() {
            const searcher = document.getElementById('searcher');
            const items = document.querySelectorAll('.document-item');
            let timeout = null;
            if (!searcher || !items) {
                return false;
            }

            searcher.addEventListener('input', (event) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    const query = event.target.value.toLowerCase();
                    if (query.length >= 2) {
                        this.quicksearchOnBefore();
                        items.forEach(item => {
                            const searchables = item.querySelectorAll('.searchable');
                            let matchFound = false;
                            searchables.forEach(searchable => {
                                const text = searchable.textContent.toLowerCase();
                                if (text.includes(query)) {
                                    matchFound = true;
                                    this.quicksearchShow(item, query);
                                }
                            });

                            if (!matchFound) {
                                this.quicksearchHide(item);
                            }
                        });
                        this.quicksearchOnAfter();
                    } else {
                        items.forEach(item => item.classList.remove('hidden'));
                        this.quicksearchOnAfter();
                    }
                }, 500);
            });
        },
        quicksearchShow(item, query) {
            item.classList.remove('hidden');
            const children = item.querySelectorAll('.searchable');
            children.forEach(child => {
                const textNodes = Array.from(child.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
                textNodes.forEach(textNode => {
                    const index = textNode.textContent.toLowerCase().indexOf(query);
                    if (index > -1) {
                        const regex = new RegExp(query, "gi");
                        const newText = textNode.textContent.replace(regex, "<span class=\"search-highlight bg-cerulean/20\">$&</span>");
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newText;
                        while (tempDiv.firstChild) {
                            textNode.parentNode.insertBefore(tempDiv.firstChild, textNode);
                        }
                        textNode.parentNode.removeChild(textNode);
                        this.searchElements.push(child);
                    }
                });
            });
            document.querySelector(`.list-support[data-section='${item.dataset.section}']`).classList.remove('hidden');
        },
        quicksearchHide(item) {
            item.classList.add('hidden');
            const section = item.dataset.section;
            const sectionItems = document.querySelectorAll(`.list-container.list-support[data-section='${section}'] .document-item`);
            const allHidden = Array.from(sectionItems).every(sectionItem => sectionItem.classList.contains('hidden'));
            if (allHidden) {
                document.querySelector(`.list-support[data-section='${section}']`).classList.add('hidden');
                document.querySelector(`.table-head-row[data-section='${section}']`).classList.add('hidden');
            }
        },
        quicksearchOnBefore() {
            this.quicksearchRemoveHighlight();
        },
        quicksearchOnAfter() {
            const searcher = document.getElementById('searcher');
            if (searcher.value === '') {
                document.querySelectorAll('.document-item, .list-support, .table-head-row').forEach(item => item.classList.remove('hidden'));
                this.quicksearchRemoveHighlight();
            }
        },
        quicksearchRemoveHighlight() {
            const openSpanRegex = new RegExp('<span class="search-highlight bg-cerulean/20">', "gi");
            const closeSpanRegex = new RegExp('</span>', "gi");
            if (this.searchElements.length === 0) {
                return;
            }
            this.searchElements.forEach(element => {
                let text = element.innerHTML;
                text = text.replace(openSpanRegex, '');
                text = text.replace(closeSpanRegex, '');
                element.innerHTML = text;
            });
            this.searchElements = [];
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll;
        this.setupLazyLoad();

        // clear any open dropdowns when the document is clicked, unless it's a button toggle or a dropdown menu
        document.addEventListener('click', function (e) {
            if (e.target.className.indexOf('dropdown-toggle') !== -1
                || e.target.className.indexOf('dropdown-menu') !== -1
                || hasParentsWithClass(e.target, 'dropdown-menu')) {
                return false;
            }
            store.dropdownOpen = null;
        });
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);

    },
    mounted() {
        this.setupScrollHelper();
        this.handleScroll();
        this.quicksearchInit();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});




app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');


function findParentsWithClass(target, className) {
    let currentElement = target;
    const parents = [];
    while (currentElement) {
        if (currentElement.classList && currentElement.classList.contains(className)) {
            parents.push(currentElement);
        }
        currentElement = currentElement.parentNode;
    }
    return parents;
}

function hasParentsWithClass(target, className) {
    const parents = findParentsWithClass(target, className);
    return (parents.length > 0);
}
